import { CaretRight } from "@phosphor-icons/react";

import InviteMemberModal from "common/components/InviteMemberModal";
import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function InviteTeamMember() {
  const isDesktop = useTwBreakpoint("lg");

  return (
    <InviteMemberModal
      buttonComponent={
        <Button
          rightIcon={isDesktop && <CaretRight />}
          size="sm"
          intent={isDesktop ? "default" : "iconOnly"}
        >
          {isDesktop ? "Invite members" : <CaretRight />}
        </Button>
      }
    />
  );
}
